import React from "react";
import GetStarted from "../DocumentationSections/GetStarted/GetStarted";
import SupportedCapabilities from "../DocumentationSections/SupportedCapabilities/SupportedCapabilities";
import Standards from "../DocumentationSections/Standards/Standards";
import Mappings from "../DocumentationSections/Mappings/Mappings";
import CodeTerms from "../DocumentationSections/CodeTerms/CodeTerms";
import SideBar from "./SideBar/SideBar";
import Overview from "../DocumentationSections/Overview/Overview";
import "./Documentation.scss";

function Documentation() {
  return (
    <div id="documentation-page">
      <div className="sidebar-container">
        <SideBar />
      </div>
      <div className="page-content">
        <Overview />
        <GetStarted />
        <SupportedCapabilities />
        {/* <Standards /> */}
        {/* <Mappings />
        <CodeTerms /> */}
      </div>
    </div>
  );
}

export default Documentation;
